import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/ThreatTypes'
)

export const mapPopupTextByName = {
  'Business Email Compromise':
    'Financial Fraud / Gift Card Request / Fraudulent Request. Business Email Compromise (BEC) attacks are sophisticated scams where attackers impersonate executives or employees to deceive other employees into transferring funds or sensitive information.',
  'Polymorphic Phishing':
    'Bulk phishing efforts usually feature messages that are broadly applicable and somewhat credible to a diverse audience. This type of phishing is a widespread issue across various sectors and continues to be a major point of concern in the field of cybersecurity',
  'Bulk Phishing':
    'Bulk Phishing efforts usually feature messages that are broadly applicable and somewhat credible to a diverse audience. This type of phishing is a widespread issue across various sectors and continues to be a major point of concern in the field of cybersecurity.',
  'Credential Theft':
    'Credential theft attacks are designed to trick recipients into revealing their sensitive login information, often by posing as legitimate institutions or services.',
  'Suspected Malicious Content':
    'Emails containing malicious content deliver harmful attachments or links aiming to infect devices or steal data from recipients.',
  'Financial Fraud':
    'Financial fraud attacks manipulate recipients into sharing financial information or making unauthorized transactions.',
  'Advance-fee Scam':
    'Advance Fee attacks involve scammers requesting an upfront payment or fee under false pretenses, promising a larger reward in return, but ultimately aiming to defraud recipients without delivering the promised benefits.',
  Extortion:
    'Extortion attacks threaten to expose sensitive or embarrassing information about recipients unless they pay a sum of money to the attacker, exploiting fear and urgency to manipulate victims into compliance.',
  'Vendor Scam':
    'Scams employ various deceitful tactics to trick recipients into providing money, personal information, or access to sensitive data, often by offering fake opportunities or creating a sense of urgency.',
  'VIP Impersonation': 'Suspected impersonation of a VIP employee.',
  'Vishing Attack':
    'Phone phishing, also known as "vishing," is a type of social engineering attack where scammers use phone calls to deceive individuals into revealing sensitive information, such as passwords or financial details, by posing as legitimate organizations or authorities.',
  'Invoice Phishing':
    'Invoice phishing attacks involve fraudulent emails or messages that appear to be from legitimate sources, often impersonating well-known companies or vendors, in order to trick recipients into paying for fake invoices or unauthorized services, or steal credentials.',
  'Account Takeover (ATO)':
    "Account Takeover (ATO) involves cybercriminals gaining unauthorized access to a person's online accounts, often using stolen credentials obtained through phishing or other methods, enabling them to control the account, steal sensitive information, or carry out malicious activities in the victim's name.",
  'Vendor Email Compromise':
    "Vendor Email Compromise (VEC) attacks compromise or impersonate the email accounts of legitimate vendors, suppliers, or business partners. They then use these compromised accounts to send fake invoices or payment requests to the targeted organization's employees, tricking them into making payments to fraudulent accounts.",
  'Image-Based Attack':
    'Image phishing tricks users into clicking on seemingly legitimate images. These images may contain hidden links that steal personal information when clicked.',
  'QR Code Attack':
    'QR code phishing involves fake QR codes that look real. When scanned, they take users to malicious websites designed to steal login credentials or financial data.',
}

export const fakeData = {
  total: 17,
  counts: [
    {
      name: 'VIP Impersonation',
      value: 9,
      percentage: 47,
    },
    {
      name: 'Business Email Compromise',
      value: 2,
      percentage: 11.76470588235294,
    },
    {
      name: 'Credential Theft',
      value: 2,
      percentage: 11.76470588235294,
    },
    {
      name: 'Advance-fee Scam',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Extortion',
      value: 1,
      percentage: 0.08235294117647,
    },
    {
      name: 'Invoice Phishing',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Lottery Scam',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Polymorphic Phishing',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Scam Vendor',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Sextortion',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Suspected Malicious Content',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Vendor Email Compromise',
      value: 1,
      percentage: 5.88235294117647,
    },
    {
      name: 'Vishing Attack',
      value: 1,
      percentage: 5.88235294117647,
    },
  ],
}

export const THREATS_LOG_TYPES = ['Suspicious email detected', 'Suspicious email reported']

export const ERROR_MESSAGE = 'The requested data cannot be displayed. Please try again later.'
export const NO_DATA_MESSAGE =
  'There are no threat types available to be shown within the chosen time frame at this moment.'

export const FISHING_WIDGET_NO_DATA_MESSAGE =
  "We couldn't find any phishing attacks within the chosen timeframe. Try expanding your date range to see results."
